<template>
    <Modal2
        @cancel="$emit('cancel')"
        @ok="saveButtonClickHandler"
        show-footer
        :ok-text="'Save'"
        :title="id ? $t('chatbotv2.editEntries') : $t('chatbotv2.newEntries')"
    >
        <div id="cb-entries">
            <div class="error-message-container">
                <a-alert :message="errorMessage" v-if="isError" type="error" show-icon />
                <a-alert :message="saveMessage" v-if="isSave" type="success" show-icon />
            </div>
            <div class="form-content">
                <div class="title-form-head">
                    <input class="form-input" :placeholder="$t('chatbotv2.entryName')" v-model="entitiesName" />
                </div>
                <div class="synonyms">
                    <div class="synonyms-title">
                        <div>{{ $t("chatbotv2.entries") }}</div>
                        <div class="add-button" @click="addEntryClickHandler">
                            <md-icon>add</md-icon>
                        </div>
                    </div>
                    <div class="synonyms-list">
                        <div class="empty-list" v-if="entries.length <= 0">
                            {{ $t("chatbotv2.youHaveNoEntries") }}
                        </div>
                        <div class="list-wrapper">
                            <EntriesListItem
                                v-for="(entry, index) in entries"
                                :key="`${index}`"
                                :initial-data="entry"
                                @delete-entry="deleteEntry(index)"
                                @update-entry="(args) => updateEntry(args, index)"
                                @error="sendError"
                                :open="openedEntryId === entry.value"
                                :on-opened="() => (openedEntryId = entry.value)"
                                :on-closed="() => (openedEntryId = null)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Modal2>
</template>

<script>
import EntriesListItem from "./EntriesListItem";
import SideMenuBar from "../../SideMenuBar";
import { CHATBOT_API } from "../../../../../api/chatbotv2";
import ChatbotMenu from "../../ChatbotMenu.vue";
import Modal2 from "../../../../../components/common/Modal2.vue";
import { mapActions } from "vuex";

let timeoutIndex;

export default {
    name: "Entries",
    components: {
        Modal2,
        ChatbotMenu,
        EntriesListItem,
        SideMenuBar,
    },
    props: ["id"],
    data() {
        return {
            entitiesName: "",
            entries: [],
            isUpdate: false,
            isError: false,
            isSave: false,
            errorMessage: "",
            saveMessage: "",
            itemsHasError: new Set(),
            openedEntryId: null,
        };
    },
    methods: {
        ...mapActions({
            createUserEntities: "CB/createUserEntities",
            updateUserEntities: "CB/updateUserEntities",
        }),
        checkEntriesIsValid() {
            const self = this;
            if (this.entries.length === 0) {
                return this.sendError("Must be at least one entry");
                return false;
            }
            for (let entry of this.entries) {
                if (entry.value.length == 0 || entry.synonyms.length < 1) {
                    console.error("Empty entry", self.$t("chatbotv2.emptyError"));
                    return false;
                }
                const otherEntryNames = self.entries.map((entry) => entry.value).filter((x) => x !== entry.value);
                const isUnique = !otherEntryNames.includes(entry.value);
                if (!isUnique) {
                    console.error("Duplicate entry");
                    return false;
                }
            }
            return true;
        },
        async saveButtonClickHandler() {
            if (!this.entitiesName || this.entitiesName.length === 0) {
                return this.sendError(this.$t("chatbotv2.entityNameCantBeEmpty"));
            }
            if (!this.checkEntriesIsValid()) {
                console.error("Entries are not valid");
                this.sendError("Entries are not valid");
                return;
            }
            if (this.isUpdate) {
                const response = await this.updateUserEntities({
                    id: this.id,
                    name: this.entitiesName,
                    entries: this.entries,
                });
                if (response.isSuccess === false) {
                    return this.sendError(this.$t("chatbotv2.entityNameMustBeUnique"));
                }
                this.$notification.success({
                    message: "Başarılı",
                    description: this.$t("chatbotv2.entityhasbeenUpdatedSuccessfully"),
                });
                this.$emit("cancel");
                return;
            }
            const response = await this.createUserEntities({ name: this.entitiesName, entries: this.entries });
            if (response.isSuccess === false) {
                return this.sendError(this.$t("chatbotv2.entityNameMustBeUnique"));
            }

            this.$notification.success({
                message: "Başarılı",
                description: this.$t("chatbotv2.entityhasbeenUpdatedSuccessfully"),
            });
            this.$emit("cancel");
        },
        updateEntry(entry, index) {
            this.$set(this.entries, index, entry);
            this.openedEntryId = entry.value;
        },
        deleteEntry(index) {
            this.entries = this.entries.filter((_, _index) => _index !== index);
        },
        sendError(message) {
            if (this.isError == true) {
                return;
            }
            if (timeoutIndex) {
                clearTimeout(timeoutIndex);
            }
            this.isError = true;
            this.errorMessage = message;
            timeoutIndex = setTimeout(() => {
                this.isError = false;
            }, 4000);
        },
        sendSave(message) {
            this.openedEntryId = null;
            if (timeoutIndex) {
                clearTimeout(timeoutIndex);
            }
            this.isError = false;
            this.isSave = true;
            this.saveMessage = message;
            timeoutIndex = setTimeout(() => {
                this.isSave = false;
            }, 4000);
        },
        addEntryClickHandler() {
            this.entries = [
                ...this.entries,
                {
                    value: "",
                    synonyms: [],
                },
            ];
        },
    },
    async mounted() {
        if (this.id) {
            const data = await CHATBOT_API.conditionalGetEntities({ id: this.id }).then((x) => x.data);
            if (data) {
                this.entitiesName = data[0].name;
                this.entries = data[0].entries;
                this.isUpdate = true;
            }
        }
    },
};
</script>
<style lang="scss">
#cb-entries {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .error-message-container {
        width: 100%;
    }

    .form-content {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .title-form-head {
            width: 100%;
        }

        .form-input {
            border: none;
            padding: 5px 10px;
            width: 100%;
        }

        .form-select-input {
            padding: 0;
            width: 100%;

            .ant-select-selection {
                border: none !important;
                background: white !important;
                border-radius: 0;
            }
        }

        .synonyms {
            display: flex;
            flex-direction: column;
            gap: 5px;

            .synonyms-list {
                .list-wrapper {
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                }
            }

            .synonyms-title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                font-size: 18px;
            }

            .add-button {
                width: 25px;
                height: 25px;
                border-radius: 20px;
                background: dodgerblue;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                i {
                    color: white;
                }
            }
        }
    }
}
</style>
